import React from 'react';
import {
  FaReply
} from 'react-icons/fa';

export const rsvpMenuItems = [
  {
    name: 'RSVPs',
    path: '/rsvps/dashboard',
    icon: <FaReply />,
    permission: null
  }
];
